import { call, put, takeLatest } from "redux-saga/effects";
import {
    updateConsentRequest,
    updateConsentSuccess,
    updateConsentFailure,
} from "../slice/consentSlice";

import { updateConsentApi } from "@src/api/apiService";

function* updateConsent(
    action: ReturnType<typeof updateConsentRequest>
): Generator<any, void, any> {
    try {
        const response = yield call(
            updateConsentApi,
            action.payload
        );

        yield put(
            updateConsentSuccess(response.data)
        );
    } catch (error: any) {
        yield put(
            updateConsentFailure(
                error?.response?.data?.detail ||
                error?.message ||
                "Unknown error"
            )
        );
    }
}

export function* consentSaga() {
    yield takeLatest(
        updateConsentRequest.type,
        updateConsent
    );
}